import { ReactNode } from 'react';

import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system/styleFunctionSx';
import useMediaQuery from '@mui/system/useMediaQuery';

type Props = {
    children: ReactNode;
    sx?: SystemStyleObject;
};

const BasePaper = ({ children, sx = {} }: Props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.only('mobile'));
    const isTablet = useMediaQuery(theme.breakpoints.only('tablet'));

    return (
        <Paper
            sx={[
                {
                    maxWidth: '1200px',
                    minWidth: isTablet ? '640px' : 'unset',
                    width: '100%',
                    padding: 5,
                    borderRadius: isMobile ? 0 : theme.spacing(0.5),
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                },
                sx,
            ]}
            elevation={0}
        >
            {children}
        </Paper>
    );
};

export default BasePaper;
